import type { CreateRoomInput } from '@sunrise-ui/api/events';
import { useSnackbar } from '@sunrise-ui/primitives';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../constants/QueryKeys';
import { roomsApi, useAuthMutation } from '../utils/api';

const { roomsKey } = QueryKeys.rooms;

export const useCreateRoom = () => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useAuthMutation({
    async mutationFn(createRoomInput: CreateRoomInput) {
      const response = await roomsApi.createRoomRoomsPost({
        createRoomInput,
      });
      return response.data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: [roomsKey] });
    },
    async onError() {
      showSnackbar({
        text: 'Failed to create room. Please try again.',
        type: 'error',
      });
    },
  });
};
